import WeatherDescription from './WeatherDescription'
export default WeatherDescription;